<template>
  <div class="service">
    <div class="search-input">
      <van-search
        v-model="form.serviceName"
        shape="round"
        placeholder="请输入关键字查询"
        @search="handleSearch"
      />
  </div>
    <div class="nav">
      <div :class="actNavItem=='one'?'nav-item active-items':'nav-item'" @click="chageNav('two')">
        服务申请
        <div v-show="actNavItem=='two'" class="underline"></div>
      </div>
      <div :class="actNavItem=='two'?'nav-item active-item':'nav-item'" @click="chageNav('one')">
        第三方服务
        <div v-show="actNavItem=='one'" class="underline"></div>
      </div>
    </div>
    <div class="list" v-if="actNavItem=='two'">
      <list-item
        @click="togglePage('serviceDetail', item)"
        v-for="item in list"
        :key="item.id"
        :item="item"
      ></list-item>
    </div>
    <!-- 第三方服务 -->
    <div class="list" v-if="actNavItem=='one'">
      <list-item
        @click="togglePage('thirdDetail', item)"
        v-for="item in list"
        :key="item.id"
        :item="item"
      ></list-item>
    </div>
  </div>
</template>

<script>
import { getServiceList } from "@/api/service.js";

import { areaCode } from "@/common/constants.js";
import { mapMutations } from "vuex";
export default {
  name: "Service",
  data() {
    return {
      form: {
        areaCode,
        openId: this.$store.state.user.openId,
        serviceName: "",
        serviceNature: "",
      },
      list: [],
      
      actNavItem: "two",
      detail:""
    };
  },
  methods: {
    ...mapMutations("service", ["setServiceName", "setServiceId"]),
    togglePage(name, item) {
      this.setServiceId(item.id);
      this.setServiceName(item.serviceName);
      window.localStorage.setItem("serviceName", item.serviceName),
        window.localStorage.setItem("serviceId", item.id),
        this.$router.push({
          name,
          query: { id: item.id, serviceName: item.serviceName },
        });
    },
    // 获取服务列表
    async getList(val) {
      if(val) this.form.serviceNature=val;
      const { list } = await getServiceList(this.form);
      this.list = list;
    },
    handleSearch() {
      if(this.actNavItem=='two'){
        this.getList('p_government');
      }
      if(this.actNavItem=='one'){
        this.getList('p_party');
      }
    },
    

    // 切换nav导航
    chageNav(val) {
      this.actNavItem = val;
      this.form.serviceName = "";
      
      if(val=='two'){
        this.getList('p_government');
      }
      if(val=='one'){
        this.getList('p_party');
      }
    },
    
  },

  mounted() {
    this.getList('p_government');
  },
};
</script>

<style lang="scss" >
.van-search{
  padding: 0 20px;
}
.service .van-card {
  padding: 0;
}
.service .list_item {
  margin: 10px 20px !important;
  border-bottom: 1px solid rgba(112, 112, 112, 0.1) !important;
}
.service .list_item .van-card {
  padding-bottom: 20px;
  height: auto !important;
}
.service .list_item .van-card .van-card__content {
  padding-top: 15px !important;
}

.service {
  .nav {
    margin: 15px 0;
    display: flex;
    align-items: center;
    .nav-item {
      width: 50%;
      height: 48px;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      text-align: center;
      color: #ecba00;
      line-height: 48px;
      background: #fff;
      border-radius: 0px 0 0 5px;
      // &:first-child{
      //   background: #ccc;
      //   border-radius: 0px 45px 0px 5px;
      // }
      // &:last-child{
      //   background: #F1F1F1;
      //   border-radius: 5px 0px 0px 45px;
      // }
    }
    .active-item {
      color: #7a7a7a;
      background: url("../../assets/images/Rectangle30.png") no-repeat;
      background-size: 100% 100%;
    }
    .active-items {
      color: #7a7a7a;
      background: url("../../assets/images/Rectangle31.png") no-repeat;
      background-size: 100% 100%;
    }
    .underline {
      width: 38px;
      height: 3px;
      background-color: #ecba00;
      margin: -7px auto 0;
    }
  }
}
</style>
